import { FC } from 'react';

import { PdfRewardsByAcademicYearList } from 'components/pdfStudent';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionRewards } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { professionRewardsSelector } from '../../../selectors';
import PdfCommonDataEntityContainer from '../dataEntityContainers/common';
import { splitRewardsByAcademicYear } from '../utils/splitRewardsByAcademicYear';

const PdfProfessionRewardContainer: FC = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const rewards = useAppSelector(professionRewardsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().professionRewards });

  const hasData = rewards.content.length > 0;

  const academicYearData = splitRewardsByAcademicYear(rewards, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Награды" Icon={IconWidgetProfessionRewards}>
      {hasData && <PdfRewardsByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfProfessionRewardContainer;
